import { AppAreaConfig } from '@/funnels/@types'
import female from '../fasting/female'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-mediterranean-diet',
	landing: {
		ids: ['loader-f-mediterranean-diet'],
		route: {
			path: '/mediterranean-diet-f',
			name: 'female-mediterranean-diet-funnel',
		},
	},
	funnel: {
		id: 'ob-female-funnel-mediterranean-diet',
		route: {
			path: '/mediterranean-diet-f/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-mediterranean-diet-onboarding',
		},
		slug: 'female-mediterranean-diet',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: female,
				page: 'target-zones',
			},
		},
	},
}

export default appAreaConfig
